import { Schema, number, array, string } from 'lib/schema';

export default class EpisodePublishHistory extends Schema {
  @string id = { default: null };

  @number numLoaded = { default: 0 };

  @number numTotal = { default: 0, path: 'total' };

  @array items = { default: () => [] };
}
